import moment from 'moment';
import { MessageProps } from '../../../typings/messages';

export function isSameDay(currentMessage: MessageProps, diffMessage: MessageProps) {
    if (!diffMessage.createdAt) {
        return false;
    }

    const currentCreatedAt = moment(currentMessage.createdAt);
    const diffCreatedAt = moment(diffMessage.createdAt);

    if (!currentCreatedAt.isValid() || !diffCreatedAt.isValid()) {
        return false;
    }

    return currentCreatedAt.isSame(diffCreatedAt, 'day');
}

export function isSameUser(currentMessage: MessageProps, diffMessage: MessageProps) {
    return diffMessage.chatMemberCode === currentMessage.chatMemberCode;
}
